import React, { useState } from 'react';
import { arrayOf, array, bool, func, number, shape, string } from 'prop-types';
import { filterSelectedJobs } from '../../../../../lib/rulesBasedPricingHelpers';
import { Checkbox, Pagination, Grid, Divider, ScrollArea} from '@mantine/core';
import OrgJobRow from '../OrgJobRow/OrgJobRow';
import Placeholder from 'ps-components/Placeholder/Placeholder';

const STEP = 50;

const OrgJobsList = ({
  isSelected,
  orgJobs,
  selectedJobs,
  toggleJobSelected,
  useJobCodeKey,
  replacementTokens,
  toggleSelectAllOrgJobs,
  selectAllFilteredJobs,
  orgJobsTotalCount,
  handlePageChange,
  activePage
}) => {
    
  const [currentSelectedPage, setCurrentSelectedPage] = useState(1);
  const handleSelectedJobsPageChange = (page) => {
    setCurrentSelectedPage(page);
  };
  const isSelectAllChecked = filterSelectedJobs(orgJobs, selectedJobs).length === orgJobs.length;
  
  const selectedJobsStartIndex = (currentSelectedPage - 1) * STEP;
  const selectedJobsEndIndex = currentSelectedPage * STEP;
  
  const paginatedSelectedJobs = selectedJobs.slice(selectedJobsStartIndex, selectedJobsEndIndex);
  
  const jobs = isSelected ? orgJobs : paginatedSelectedJobs;
  const totalItems = isSelected ? orgJobsTotalCount : selectedJobs.length;
  const currentPage = isSelected ? activePage : currentSelectedPage;
  const handlePageChangeFunction = isSelected ? handlePageChange : handleSelectedJobsPageChange;
  if (!jobs.length) {
    return (
      <div className="org-job__placeholder">
        <Placeholder secondaryText="There are no results for your search." showText={true} />
      </div>
    );
  }
  return (
      <div className="org-jobs__table-container">
        <Grid>
          <Grid.Col span={1} size="lg" style={{ marginTop: 4 }}>
            <Checkbox
              checked={isSelectAllChecked || !isSelected}
              color="#0FB2F6"
              className="select-all__input"
              onChange={() =>
                selectAllFilteredJobs()
              }
              disabled={false}
            />
          </Grid.Col>
          <Grid.Col span={11} size="lg" style={{ color: '#5C5C5C', fontWeight: 515 }}>
            Job Title
          </Grid.Col>
        </Grid>
        <Divider my="md" />
        
       
        <ScrollArea.Autosize h={600} mx="auto" flex="auto">
          {jobs.map((job) => (
            <React.Fragment key={job.id}>
              <OrgJobRow
                job={job}
                selectedJobs={selectedJobs}
                toggleJobSelected={toggleJobSelected}
                replacementTokens={replacementTokens}
                useJobCodeKey={useJobCodeKey}
              />
              <Divider my="md" />
            </React.Fragment>
          ))}
        </ScrollArea.Autosize>   
      
        
        <div className="org-jobs__pagination" style={{ position: 'sticky', bottom: 0, zIndex: 1, paddingTop: 8, backgroundColor: 'white' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Pagination
              total={Math.ceil(totalItems / STEP)}
              onChange={handlePageChangeFunction}
              value={currentPage}
              //size="xl"
              size="lg"
              mt="sm"
              color="#0FB2F6"
            />
            <div style={{ display: 'inline-block', marginLeft: 'auto', whiteSpace: 'nowrap', paddingTop: 12, color: "#A9A9A9" }}>
              {totalItems > 0 && (
                <>
                  {((currentPage - 1) * STEP) + 1}-{Math.min(currentPage * STEP, totalItems)} of {totalItems}
                </>
              )}
            </div>
          </div>
          <div style={{ height: '35px' }}>&nbsp;</div>
        </div>
      </div>
    );
  }

OrgJobsList.propTypes = {
  isSelected: bool,
  orgJobs: array,
  orgJobsTotalCount: number,
  handlePageChange: func.isRequired,
  selectedJobs: array,
  toggleJobSelected: func,
  toggleSelectAllOrgJobs: func,
  selectAllFilteredJobs: func,
  replacementTokens: arrayOf(
    shape({
      token: string,
      value: string
    })
  ),
  useJobCodeKey: bool,
  activePage: number
};

export default OrgJobsList;